function parseDurationWithNoGroups(displayValue, format) {
  if (displayValue.length === 0) return null;
  const isOnlyNumbersRegex = /^[0-9]*$/;
  if (!isOnlyNumbersRegex.test(displayValue)) return "invalidFormat";
  return Number.parseInt(displayValue) * multipliers[format];
}
const multipliers = {
  hh: 3600,
  mm: 60,
  ss: 1
};
export {
  parseDurationWithNoGroups
};
//# sourceMappingURL=parseDurationNoGroups.js.map
